"use strict";

(function(window) {

	Vue.component('lab-card', {

		props: {

			'lab': {
				type: Object
			},

			'pinRed': {
				type: String
			},

			'pinDark': {
				type: String
			}

		},

		template: `
			<div class="lab-card">
			
			<div class="lab-card-header">
			
				<h3 class="h4 lab-name">
					<img v-if="lab.member" :src="pinRed" class="pin" />
					<img v-if="!lab.member" :src="pinDark" class="pin" />
					{{lab.name}}
				</h3>
				
				<div class="address">
					<p><strong>Address:</strong> {{lab.addressParse[3]}}, {{lab.addressParse[2]}} {{lab.addressParse[1]}} {{lab.addressParse[0]}}</p>
				</div>
				
			</div>
				
				<div class="lab-card-content">
				
					
					<div class="content-table">
					
						<div class="content-table-header-row">
						
							<div class="col-md-2 content-table-col certification">
								<h6>Certified</h6>
							</div>
							
							<div class="col-md-8 content-table-col details">
								<h6>Type</h6>
							</div>
							
						</div>
						
						<div v-for="(program, key) in lab.lab_programs" class="content-table-row">

								<div class="col-md-2 content-table-col certification">
									<p>{{ key }}</p>
								</div>
								
								<div class="col-md-8 content-table-col details" v-if="program.website == 'S'" >
								
									<p v-for="testgroups in program.tests">
										<span v-for="(tests, testgroup) in testgroups">
										 <span v-if="tests.length">{{ testgroup }} - {{tests.join(', ')}}</span>
										 <span v-if="!tests.length">{{ testgroup }}</span>
										</span>
									</p>
									
								</div>
								
								<div v-else class="col-md-8 content-table-col details" style="color:red">
								
									<p>
										<strong>{{program.website_label}}</strong>
									</p>
									
								</div>
		
						</div>
						
						<!--
						<div v-if="lab.mobile_labs">
						
							<hr v-if="lab.mobile_labs">
							<h5 v-if="lab.mobile_labs" class="title" style="margin-bottom: 25px">Mobile Labs</h5>
								
							<div v-for="(mobile_lab, index) in lab.mobile_labs">
								<h6>{{mobile_lab.mobile_name}}</h6>
								<div v-for="(program, key) in mobile_lab.lab_programs">
									<div class="mini-card">
										<span><strong>{{ key }}</strong></span>
										<div v-for="testGroups in program.tests">
											<div v-for="(tests, testGroup) in testGroups">
												<span v-if="tests.length">{{ replaceCategory(testGroup) }} - {{tests.join(', ')}}</span>
												<span v-if="!tests.length">{{ replaceCategory(testGroup) }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							
						</div>
						-->
						
					</div>
					
					
				</div> 
				
			</div>
		`,

		name: 'lab-card',

		methods: {

			replaceCategory (value) {

				if (!value) return value;

				if (value.toString().search(/((Category)( |-)[0-2])/gi)) {
					return value.toString().replace(/((Category)( |-)[0-2])/gi, 'Concrete');
				}

				return value;

			}

		}

	});

})(window);
